function populate_enquiry() {
    let form = document.querySelector('main form'),
        url_params = new URLSearchParams(window.location.search),
        url_source = url_params.get('source'),
        promo_page_path = '/promo-15-off-all-hand-tools-nov-24/';

    window.addEventListener('message', (event) => {
        if (
        event.data.type === 'hsFormCallback' &&
        event.data.eventName === 'onFormReady'
        ) {
            let form = document.querySelector('[id^=hs-form-]').contentDocument,
                field = form.querySelector('input[name=source_page]');

            if( url_source !== null ) {

                field.value = url_source;
                field.dispatchEvent(new Event('input', { bubbles: true }));

                let product_of_interest = 'Not applicable';
                if( url_source.startsWith('/p/') ) {
                    let product_of_interest = url_source.replace('/p/', '').replace('/', '');
                    field = form.querySelector('select[name=product_of_interest]');
                    field.value = product_of_interest;
                    field.dispatchEvent(new Event('input', { bubbles: true }));
                }

            } else if( window.location.pathname == promo_page_path ) {
                field.value = promo_page_path;
                field.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    });
    
}

populate_enquiry();